import {Component, OnDestroy, OnInit, Input} from '@angular/core';
import {UIRouter} from '@uirouter/angular';
import {DatatableViewComponent} from '@ngx-ivengi/crud';
import {Picture} from './picture.model';
import {PictureService} from './picture.service';
import {RoutePrefix} from '../shared/route-prefix';
import {FileService} from '../file/file.service';
import 'rxjs/add/operator/map';
import {AssignmentService} from '../assignment/assignment.service';
import {Assignment} from '../assignment/assignment.model';

@Component({
  selector: 'app-picture-datatable',
  templateUrl: './picture-datatable.component.html'
})
export class PictureDatatableComponent extends DatatableViewComponent<Picture> implements OnDestroy, OnInit {
  public assignmentType: string;
  public editRoute: string;
  public viewRoute: string;

  @Input() public routePrefix: RoutePrefix | RoutePrefix[];
  @Input() public viewMode: boolean = false;

  constructor(
    protected router: UIRouter,
    protected pictureService: PictureService,
    protected assignmentService: AssignmentService,
    protected fileService: FileService
  ) {
    super(pictureService);
  }

  public ngOnDestroy(): void {
    this.pictureService.clearRoutePrefix();
  }

  fetchData(): void {
    this.loading  = true;
    this.pictureService.getAll(this.requestParams).map((pictures: Picture[]) => {
      return pictures.map((picture) => {
        return picture.setFileSrc(this.fileService.getLinkById(picture.fileId));
      });
    } ).subscribe(data => {
      this.rows = data;
      this.loading = false;
    });
  }

  ngOnInit(): void {
    const stateParts = this.router.stateService.$current.name.split('.');
    this.assignmentType = stateParts[1] || '';
    this.editRoute      = `assignment.${this.assignmentType}.edit.channel.edit.picture.edit`;
    this.viewRoute      = `assignment.${this.assignmentType}.edit.channel.edit.picture.view`;

    // this.assignmentService.get(this.router.stateService.params.assignmentId).subscribe((assignment: Assignment) => {
    //   this.assignmentType = assignment.type.toLowerCase();
    // });

    if(this.routePrefix) {
      const prefixParts = (this.routePrefix instanceof Array) ? this.routePrefix : [this.routePrefix];

      const prefix  = prefixParts.map((item) => {
        return `${item.entity}/${item.entityId}`;
      });

      this.pictureService.setRoutePrefix(prefix.join('/').toLowerCase());
    }

    this.fetchData();
  }

  public deletePicture(picture: Picture) {
    this.pictureService.delete(picture).subscribe((result) => {
      this.router.stateService.go(this.router.stateService.$current.name, this.router.stateService.params, {reload: true});
    });
  }

  public onRowClick(event) {
    if (event.type !== 'dblclick' || typeof event.column === 'undefined' || event.column.prop === 'menu' || typeof event.row === 'undefined') {
      return;
    }
    this.router.stateService.go(this.viewRoute, { pictureId: event.row.id }, { reload: true });
  }
}




// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/picture/picture-datatable.component.ts